'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

export function useTabFocus() {
  const { data: session, status, update } = useSession();

  useEffect(() => {
    if (status !== 'authenticated') {
      return;
    }

    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        if (!session?.accessTokenExpires) {
          return;
        }

        const expiresAt = session.accessTokenExpires;
        const now = Date.now();
        const timeUntilExpiry = expiresAt - now;
        const twoMinutes = 2 * 60 * 1000;

        if (timeUntilExpiry < twoMinutes && timeUntilExpiry > 0) {
          console.log('Tab focused, refreshing token...');
          try {
            await update();
            console.log('Token refreshed on tab focus');
          } catch (error) {
            console.error('Failed to refresh token on tab focus:', error);
          }
        } else if (timeUntilExpiry <= 0) {
          console.log('Token expired while tab was inactive, refreshing...');
          try {
            await update();
            console.log('Expired token refreshed on tab focus');
          } catch (error) {
            console.error('Failed to refresh expired token:', error);
          }
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [session, status, update]);

  return null;
}
